import React from 'react';
import { Alert, Button } from 'antd';
import { blockingHintOf, blockingLineOf, type BlockingJob } from './workflowFourBlockingUtils';

interface Props {
  jobs: BlockingJob[];
  busy: boolean;
  onRelease: (job: BlockingJob) => void;
}
/** Băng «Đang có việc khác chạy» (mọi bước của khung 4 bước): mỗi việc một dòng; chỉ việc `releasable` mới có nút «Gỡ việc treo». */
const FourBlockingBanner: React.FC<Props> = ({ jobs, busy, onRelease }) => {
  if (!jobs.length) return null;
  return <>{jobs.map((job) => <Alert key={job.id} className="wf4-banner" type="warning" showIcon data-testid={`blocking-${job.id}`} style={{ marginBottom: 12 }}
    message={blockingLineOf(job)}
    description={blockingHintOf(job)}
    action={job.releasable ? <Button size="small" danger disabled={busy} onClick={() => onRelease(job)}>Gỡ việc treo</Button> : undefined} />)}</>;
};
export default FourBlockingBanner;
